module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Registration Completed","desc":"ERegistration Completed. Please login the system."},"zh_hk":{"title":"註冊已完成","desc":"電子註冊已完成。請登入系統."},"zh_cn":{"title":"注册已完成","desc":"电子注册已完成。请登入系统."}}')
  delete Component.options._Ctor
}
